import "./Loader.css";
import useSize from "../../Utils/useSize/useSize";

export default function Loader() {
  const windowSize = useSize();

  return (
    <div
      className="loader-container"
      style={{height: windowSize[1] }}
    >
      <div className="logo">
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Chart Line */}
          <path
            d="M10 60 L35 30 L55 50 L80 20"
            stroke={window.THEME_COLOR}
            strokeWidth="6"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span style={{color : window.THEME_COLOR}} className="logo-text">{window.APP_NAME}</span>
      </div>
    </div>
  );
}
